import { createAsyncThunk } from '@reduxjs/toolkit'
import Container from 'typedi'
import i18n from 'i18n'

import { ApplicationState } from '@/state/root.models'
import { RestApiService } from '@/services'
import {
  setLoadingFullAction,
  setSnackbarAction,
} from '@/state/ui/global/slices/index.slices'

import { removeEmptyProp } from '@/utils'
import ActionTypes from '../constants'
import { DeleteWalletPayload, DeleteWalletResponse } from '../models'

import { WALLET } from './api.routes'
import { getAllWalletThunk } from './get-all.thunk'

const restApiService: RestApiService = Container.get(RestApiService)

const deleteWalletThunk = createAsyncThunk(
  ActionTypes.DELETE_WALLET,
  async (payload: DeleteWalletPayload, thunkAPI) => {
    try {
      restApiService.requestParams = {
        method: 'POST',
        endpoint: WALLET.DELETE,
        body: payload,
      }

      const { auth, wallet } = thunkAPI.getState() as ApplicationState

      thunkAPI.dispatch(setLoadingFullAction(true))

      const response: DeleteWalletResponse = await restApiService.sendData(
        auth.brand.siteId.toString(),
        auth.token,
      )

      thunkAPI.dispatch(setLoadingFullAction(false))

      let message = i18n.t('messages.successfully', {
        item: `${i18n.t('wallet.wallet')} ${payload.walletId}`,
        what: i18n.t('labels.deleted'),
      })

      if (response.status === 200) {
        thunkAPI.dispatch(getAllWalletThunk(removeEmptyProp(wallet.filters)))
      } else {
        message = i18n.t('messages.errorOccurred')
      }

      thunkAPI.dispatch(
        setSnackbarAction({
          message,
          open: true,
          variant: response.status === 200 ? 'success' : 'error',
        }),
      )

      return response
    } catch (error) {
      thunkAPI.dispatch(setLoadingFullAction(false))
      throw error
    }
  },
)

export default deleteWalletThunk
